export const sortArrayAscendingorder = (array,value) => {
  // console.log("SearchArray",array,value,array[0]["Name?.props?.children?.props?.text"])
  //console.log("SearchArray",array)
  if(value == true){
    return Array.isArray(array) ? (array?.sort((a, b) => {
      const textA = a?.Name?.props?.children?.props?.text?.toLowerCase();
      const textB = b?.Name?.props?.children?.props?.text.toLowerCase();
      const numA = parseFloat(a?.text);
      const numB = parseFloat(b?.text);
      if (!isNaN(numA) && isNaN(numB)) {
        return 1;
      }
      if (isNaN(numA) && !isNaN(numB)) {
        return -1;
      }
  
      if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB;
      }
  
      return textA?.localeCompare(textB, "en-US", { caseFirst: "upper" });
    })):[]
  }else if(value == "props?.children"){
    return Array.isArray(array) ? (array?.sort((a, b) => {
      const textA = a?.clauseName?.props?.children.toLowerCase();
      const textB = b?.clauseName?.props?.children?.toLowerCase();
      const numA = parseFloat(a?.text);
      const numB = parseFloat(b?.text);
      if (!isNaN(numA) && isNaN(numB)) {
        return 1;
      }
      if (isNaN(numA) && !isNaN(numB)) {
        return -1;
      }
  
      if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB;
      }
  
      return textA?.localeCompare(textB, "en-US", { caseFirst: "upper" });
    })):[]
  }else{
    return Array.isArray(array) ? (array?.sort((a, b) => {
      const textA = a?.[value]?.toLowerCase();
      const textB = b?.[value]?.toLowerCase();
      const numA = parseFloat(a?.text);
      const numB = parseFloat(b?.text);

  
      if (!isNaN(numA) && isNaN(numB)) {
        return 1;
      }
      if (isNaN(numA) && !isNaN(numB)) {
        return -1;
      }
  
      if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB;
      }
  
      return textA?.localeCompare(textB, "en-US", { caseFirst: "upper" });
    })):[]
  }
  };